module.exports = __webpack_public_path__ + "img/фон_п_в.9ee7a72e.jpg";